import pick from 'lodash/pick'
import { Toast } from '@bcz/nib'
import { registerEvents } from '@/utils'
import { isDevMode } from '@/utils/mode'

export function registerAjaxHooks() {
  return registerEvents({
    'ajax:success': ({ data, meta }) => {
      if (isDevMode) {
        console.groupCollapsed(`${meta.options.method} ${[meta.url]}`)
        const contents = {
          ['[Request Payload]']: meta.options.body || {},
          ['[Response Data]']: data,
        }
        console.log(JSON.stringify(contents, null, 2))
        console.groupEnd()
      }
    },

    'ajax:error': ({ error, meta }) => {
      if (isDevMode) {
        console.group(`${meta.options.method} ${[meta.url]}`)
        const contents = {
          ['[Request Payload]']: meta.options.body || {},
          ['[Response Error]']: pick(error, ['code', 'message', 'detail']),
        }
        console.log(JSON.stringify(contents, null, 2))
        console.groupEnd()
      }

      if (meta?.globalError !== false) {
        setTimeout(() => {
          Toast.show({
            content: error?.detail?.message || error?.message || '接口调用失败，请稍后再试',
            duration: 1000,
            position: 'bottom',
          })
        })
      }
    },
  })
}
